import { Card, List, Tag, TextareaItem } from "antd-mobile";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import instance from "../../../util/axios";
import styled from "styled-components";

const EnterpriseContainer = styled.div`
  .title {
    padding: 14px;
    font-weight: 800;
  }
  .am-card.am-card-full::after {
    height: 0 !important;
  }
  .am-card-body {
    padding: 0;
  }
  .am-list-body {
    .am-textarea-label {
      font-size: 14px;
    }
    .am-textarea-control {
      textarea {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
      }
    }
  }
`;

export default function EnterpriseDetails() {
  const params = useParams<{ name: string }>();

  const [result, setResult] = useState<any>(null);
  function getEntTyper(type: string) {
    switch (type) {
      case "0":
        return "公司";
      case "1":
        return "社会组织";
      case "3":
        return "香港公司";
      case "4":
        return "事业单位";
      case "6":
        return "基金会";
      case "7":
        return "医院";
      case "8":
        return "海外公司";
      case "9":
        return "事务所";
      case "10":
        return "学校";
      case "-1":
        return "其他";

      default:
        return "其他";
    }
  }
  useEffect(() => {
    (async () => {
      await instance
        .post("/crm/industryCommerce/getDetails/", params)
        .then((res) => {
          if (res.status == 200 && res.data.Status == "200") {
            setResult(res.data.Result);
          }
        });
    })();
  }, [params]);

  return (
    <EnterpriseContainer>
      {result == null ? (
        ""
      ) : (
        <div
          style={{
            background: "#ffffff",
          }}>
          <Card full>
            <Card.Header
              title={result.Name}
              thumb={result.ImageUrl}
              thumbStyle={{ width: 40 }}
              // extra={<Tag selected>{result.Status.split("（")[0]}</Tag>}
            />
            <Card.Body>
              <List>
                <TextareaItem
                  title="法定代表人："
                  autoHeight
                  labelNumber={6}
                  editable={false}
                  value={result.OperName}
                />
                <TextareaItem
                  title="统一社会信用码："
                  autoHeight
                  labelNumber={8}
                  editable={false}
                  value={result.CreditCode}
                />
                <TextareaItem
                  title="成立时间："
                  autoHeight
                  labelNumber={5}
                  editable={false}
                  value={result.StartDate}
                />
                <TextareaItem
                  title="地址："
                  autoHeight
                  labelNumber={5}
                  editable={false}
                  value={result.Address}
                />
              </List>
            </Card.Body>
          </Card>
          <div className="title">企业工商信息</div>
          <List>
            <TextareaItem
              title="统一社会信用码："
              autoHeight
              labelNumber={8}
              editable={false}
              value={result.CreditCode}
            />
            <TextareaItem
              title="企业名称："
              autoHeight
              labelNumber={8}
              editable={false}
              value={result.Name}
            />
            <TextareaItem
              title="企业类型："
              autoHeight
              labelNumber={8}
              editable={false}
              value={result.EconKind}
            />
            <TextareaItem
              title="企业类型："
              autoHeight
              labelNumber={8}
              editable={false}
              value={getEntTyper(result.EntType)}
            />
            <TextareaItem
              title="企业状态："
              autoHeight
              labelNumber={8}
              editable={false}
              value={result.Status}
            />
            <TextareaItem
              title="成立时间："
              autoHeight
              labelNumber={8}
              editable={false}
              value={result.StartDate}
            />
            <TextareaItem
              title="更新日期："
              autoHeight
              labelNumber={8}
              editable={false}
              value={result.UpdatedDate}
            />
            <TextareaItem
              title="法人Id："
              autoHeight
              labelNumber={8}
              editable={false}
              value={result.OperId}
            />
            <TextareaItem
              title="法定代表人："
              autoHeight
              labelNumber={8}
              editable={false}
              value={result.OperName}
            />
            <TextareaItem
              title="注册号："
              autoHeight
              labelNumber={8}
              editable={false}
              value={result.No}
            />
            <TextareaItem
              title="注册资本："
              autoHeight
              labelNumber={8}
              editable={false}
              value={result.RegistCapi}
            />
            <TextareaItem
              title="发照日期："
              autoHeight
              labelNumber={8}
              editable={false}
              value={result.CheckDate}
            />
            <TextareaItem
              title="组织机构代码："
              autoHeight
              labelNumber={8}
              editable={false}
              value={result.OrgNo}
            />
            <TextareaItem
              title="纳税人识别号："
              autoHeight
              labelNumber={8}
              editable={false}
              value={result.No}
            />
            <TextareaItem
              title="营业期限："
              autoHeight
              labelNumber={8}
              editable={false}
              value={`${result.TermStart}-${result.TeamEnd}`}
            />
            <TextareaItem
              title="所属地区："
              autoHeight
              labelNumber={8}
              editable={false}
              value={result.No}
            />
            <TextareaItem
              title="等级机关："
              autoHeight
              labelNumber={8}
              editable={false}
              value={result.BelongOrg}
            />
            <TextareaItem
              title="曾用名："
              autoHeight
              labelNumber={8}
              editable={false}
              value={
                result.OriginalName == null ? "" : result.OriginalName.Name
              }
            />
            <TextareaItem
              title="是否IPO上市："
              autoHeight
              labelNumber={8}
              editable={false}
              value={result.IsOnStock == "1" ? "上市" : "未上市"}
            />
            <TextareaItem
              title="上市公司代码："
              autoHeight
              labelNumber={8}
              editable={false}
              value={result.StockNumber}
            />
            <TextareaItem
              title="上市类型："
              autoHeight
              labelNumber={8}
              editable={false}
              value={result.StockType}
            />
            <TextareaItem
              title="企业Logo地址："
              autoHeight
              labelNumber={8}
              editable={false}
              value={result.ImageUrl}
            />
            <TextareaItem
              title="注册地址："
              autoHeight
              labelNumber={8}
              editable={false}
              value={result.Address}
            />
            <TextareaItem
              title="经营范围："
              autoHeight
              labelNumber={8}
              editable={false}
              value={result.Scope}
            />
          </List>
        </div>
      )}
    </EnterpriseContainer>
  );
}
